"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WorkflowPermissions;
(function (WorkflowPermissions) {
    WorkflowPermissions[WorkflowPermissions["ADMIN"] = 0] = "ADMIN";
    WorkflowPermissions[WorkflowPermissions["SHARE"] = 1] = "SHARE";
    WorkflowPermissions[WorkflowPermissions["DELETE"] = 2] = "DELETE";
    WorkflowPermissions[WorkflowPermissions["WRITE"] = 3] = "WRITE";
    WorkflowPermissions[WorkflowPermissions["READ"] = 4] = "READ";
    WorkflowPermissions[WorkflowPermissions["EXPORT"] = 5] = "EXPORT";
    WorkflowPermissions[WorkflowPermissions["EXECUTE"] = 6] = "EXECUTE";
    WorkflowPermissions[WorkflowPermissions["READ_CONTENT"] = 7] = "READ_CONTENT";
    WorkflowPermissions[WorkflowPermissions["UPDATE_CONTENT"] = 8] = "UPDATE_CONTENT";
})(WorkflowPermissions || (WorkflowPermissions = {}));
